import React from 'react';
import styles from './PaginationButtons.module.scss';
import { IconButton } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

export default function Previous({ onClick }) {
  return (
    <IconButton className={styles.page_button} onClick={onClick}>
      <NavigateNextIcon />
    </IconButton>
  );
}
